/**
 * Beställare 2 ur en upphandling — registrerad eller inte.
 *
 * Två vägar in i systemet, och vyerna ska inte behöva veta vilken som använts:
 *
 *   MED förstudie   Beställare 2 fylls i vid bokningen och får konto när
 *                   estimatet skickas. Ligger då i additionalCustomerIds.
 *   UTAN förstudie  Estimatet hoppas över, så kontot skapas först vid
 *                   offertutskicket. Fram till dess ligger uppgifterna som ett
 *                   fritt objekt på leaden.
 *
 * Läste man bara additionalCustomerIds — som offertvyn och PDF:en gjorde —
 * stod det "Ingen andra beställare" i hela mellantiden, även när BK fyllt i
 * henne. Motsvarigheten i backend är `utils/bestallare2.js`; håll dem i synk.
 *
 * Beställare 2 är den FÖRSTA EXTRAKUNDEN SOM INTE ÄR DELTAGARE — inte bara [0].
 * Övriga deltagare ligger i samma lista men står aldrig i offert eller avtal
 * (se backend/src/utils/deltagare.js).
 *
 * @param {Object} procurement
 * @returns {{ firstName, lastName, name, email, phone, registrerad }|null}
 */
export const hamtaBestallare2 = (procurement) => {
  const idAv = (x) => String(x?._id || x || '');
  const deltagare = new Set((procurement?.deltagareIds || []).map(idAv));
  const konto = (procurement?.additionalCustomerIds || []).find(x => x && !deltagare.has(idAv(x)));
  if (konto && (konto.firstName || konto.lastName || konto.email)) {
    const firstName = konto.firstName || '';
    const lastName = konto.lastName || '';
    return {
      firstName,
      lastName,
      name: `${firstName} ${lastName}`.trim(),
      email: konto.email || '',
      phone: konto.phone || '',
      registrerad: true
    };
  }

  // Fältnamnet bär svenskt tecken i databasen — hämtas som det är.
  const b2 = procurement?.leadId?.beställare2;
  if (!b2 || !(b2.firstName || b2.lastName || b2.email)) return null;

  const firstName = b2.firstName || '';
  const lastName = b2.lastName || '';
  return {
    firstName,
    lastName,
    name: `${firstName} ${lastName}`.trim(),
    email: b2.email || '',
    phone: b2.phone || '',
    registrerad: false
  };
};
